import type { AvailabilityOption, BookingIntent, PublicOffering } from './domain'

type BookingLaunchInput = {
  locationSlug: string
  date: string
  partySize: number
  offering: Pick<PublicOffering, 'id'>
  option?: AvailabilityOption
  source?: 'notify'
  accessToken?: string
}

export type BookingLaunch = {
  intent: BookingIntent
  initialOption?: AvailabilityOption
}

export function createBookingLaunch({
  locationSlug,
  date,
  partySize,
  offering,
  option,
  source,
  accessToken,
}: BookingLaunchInput): BookingLaunch {
  return {
    intent: {
      locationSlug,
      experienceId: offering.id,
      partySize,
      date,
      preferredTime: option?.localStart,
      source,
      accessToken,
    },
    initialOption: option,
  }
}
